export default "__VITE_ASSET__c0c3baf5__"